import React, { useCallback } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Stack, Typography } from "@mui/material";

import useMutate from "../../../hooks/useMutate";
import { updateTenantWorkingHours } from "../../../sevices/apiSystemSettings";
import { useResponsive } from "../../../hooks/useResponsive";
import {
  RFHTextField as RHFTextField,
  RFHToggle as RHFToggle,
} from "../../../components/RFH";
import { CustomButton } from "../../../components/Button/Button";

function WorkingHours({ initialData }) {
  const methods = useForm({
    defaultValues: initialData,
  });

  const { mutate, isPending } = useMutate(updateTenantWorkingHours, [
    "logo",
    "tenant-details",
  ]);

  const isMobile = useResponsive("down", "md");
  // Watch form values for real-time changes (optional)
  const formValues = methods.watch();

  // Function to check if any field has a value
  const isAnyFieldFilled = useCallback(() => {
    return Object.values(formValues).some((value, index) => {
      const initialValue = Object.values(initialData)[index];
      return (
        value !== undefined &&
        value !== "" &&
        value !== null &&
        value != initialValue
      );
    });
  }, [formValues, initialData, isPending]);

  const onSubmit = useCallback(
    (formData) => {
      mutate(formData);
    },
    [mutate]
  );

  return (
    <>
      <FormProvider {...methods}>
        <div className="mt-32 form-section  ">
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <div>
              <Typography className="setting-heading mb-2  ml-0">
                Working Hours
              </Typography>

              <Stack
                mt={3}
                direction={isMobile ? "column" : "row"}
                spacing={2.5}
              >
                <RHFTextField
                  name="daily_worklog_hours"
                  label="Working Hours Per Day"
                  type="number"
                  className="working-hours-text-field"
                />
              </Stack>
            </div>
            <div className="d-flex mt-32 align-items-center">
              <div className="mr-4">
                <Typography className="setting-heading  ml-0">
                  Remind Users to Enter Worklogs
                </Typography>
                <div className=" ldap-note ">
                  <Typography className="logo-note">
                    When enabled, users will see reminders to enter worklogs.
                  </Typography>
                </div>
              </div>
              <div className="ml-2">
                <RHFToggle name="daily_worklog_reminder" />
              </div>
            </div>
            <Stack alignItems="end" className="mt-32">
              <CustomButton
                variant="contained"
                type="submit"
                className="theme-bg-color working-hours-update-button"
                disabled={isPending || !isAnyFieldFilled()}
              >
                Update
              </CustomButton>
            </Stack>
          </form>
        </div>
      </FormProvider>
    </>
  );
}

export default React.memo(WorkingHours);
